// @flow
import {
  CAMPAIGN_REQUEST,
  CAMPAIGN_ERROR,
  CAMPAIGN_UPDATE
} from './constant';

import type {
  Action, Campaign
} from '../types';

export const requestCampaigns = (url: string): Action => ({
  type: CAMPAIGN_REQUEST,
  url
});

export const errorCampaign = (error: Error): Action => ({
  type: CAMPAIGN_ERROR,
  error
});

export const updateCampaign = (
  data: Campaign
): Action => ({
  type: CAMPAIGN_UPDATE,
  data
});
